import React, { useEffect, useMemo, useState } from "react";

import ShimmerWrapper from "@stadium/ui/src/components/loaders/shimmer-wrapper";

import { camelizeKeys } from "@stadium/helpers/formatter";

import ListTemplateView from "@components/all-templates/views/list-view";
import GridTemplateView from "@components/all-templates/views/grid-view";
import BuildOwnTemplateBanner from "@sharedComponents/banner/build-own-template";
import ShadowCard from "@sharedComponents/cards/shadow";

import { useInstantSearch } from "@stadium/shared/src/components/instant-search";

import { buildOwnTemplateBannerData } from "@constants/banner";
import { MOMENTS } from "@constants/routes";

import styles from "./purge-main.module.scss";

const emptyArr = [];

const TemplateViews = ({ isGridView, onTemplateSelect = () => {}, pageName = "" }) => {
  const { hits = emptyArr } = useInstantSearch();
  const [isLoading, setIsLoading] = useState(true);
  const formattedShopHits = useMemo(() => hits?.map((item) => camelizeKeys(item)), [hits]);

  useEffect(() => {
    if (hits?.length) {
      setIsLoading(false);
    }
  }, [hits]);

  if (isLoading)
    return (
      <ShimmerWrapper length={3} cardClass={styles.shadowCardCol} wrapperClass={styles.shopRow}>
        <ShadowCard customClass="chooseTemplate" />
      </ShimmerWrapper>
    );

  return (
    <div className={styles.templatesContentSection}>
      {formattedShopHits.map((hit, index) => (
        <React.Fragment key={hit.id}>
          {index === 4 && pageName !== MOMENTS && (
            <BuildOwnTemplateBanner
              key={buildOwnTemplateBannerData.name}
              data={buildOwnTemplateBannerData}
              onTemplateSelect={onTemplateSelect}
              className={styles.listingTemplateRequestBanner}
            />
          )}
          <div
            className={`${styles.templateBlockHolder} ${isGridView ? styles.gridViewClasses : ""}`}
          >
            {!isGridView ? (
              <ListTemplateView {...hit} onTemplateSelect={onTemplateSelect} pageName={pageName} />
            ) : (
              <GridTemplateView {...hit} onTemplateSelect={onTemplateSelect} pageName={pageName} />
            )}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default TemplateViews;
